import * as firebase from 'firebase';

class FirebaseTools {
  constructor() {
    const conf = {
      apiKey: 'AIzaSyAct5KbCtst7-U23sKaJj3NeMK_Q_mNV6c',
      authDomain: 'morgan-numismafantastic.firebaseapp.com',
      databaseURL: 'https://morgan-numismafantastic.firebaseio.com',
      projectId: 'morgan-numismafantastic',
      storageBucket: 'morgan-numismafantastic.appspot.com',
      messagingSenderId: '6107590395'
    };

    this.firebase = firebase.initializeApp(conf);
  }


}

export default new FirebaseTools();
